import React from 'react';
import withDataLoaded from '../with_data_loaded';
import PageSpinner from '../shared/page_spinner';
import { userLoader } from '../../actions/data_loaders';

function SecurityCenter(props) {
  return <div style={{ width: '95%', height: '80%' }}></div>;
}

export default withDataLoaded({
  WithData: SecurityCenter,
  WithoutData: PageSpinner,
  data: [userLoader],
});
